<template>
  <div class="intro">
<!--    <div class="top">
      <img :src=" top" style="width: 100%;height: 450px">
    </div>

    <div class="con_data des">
      <h1 class="blue bt">公司简介</h1>
      <div class="con">
        <div class="text">
          <p>
            北京智砼兴华科技有限公司是一家以物联网、云计算以及信息化应用等技术为依托的国家高新技术企业。公司定位为监测平台的开发商和服务商，致力于成为基础设施监测行业最好的平台开发商和服务商，公司包括技术开发与技术服务等多个部门，并在长沙建立了产品生产基地。。
          </p>
          <p>
            我们拥有一套成熟的自动化监测体系。即通过安装传感器进行数据收集，收集完毕进行集成最后到数据可视化报表呈现。目前我们平台支持桥梁、基坑、建筑物、边坡、隧道、大坝、路基、气象、尾矿库、特种设备、临时设施（高支模、塔吊等）、铁塔等20种结构物远距离实时在线监测。拥有各种结构物的必测及可测等全因素。
          </p>
          <p>
            公司开发完成的低功耗应变、位移监测设备（ZTXH-1/4Y），可以满足建筑结构数据正常采集的工况下，免维护使用时长达2年之久，待机功耗低至10微安以内，可以满足常见的建筑结构、桥梁及矿山等免维护监测，该项产品已在国内数十项场馆及建筑物中推广应用，得到了行业内广泛的认可。
          </p>
        </div>
        <div><img :src="img_1" style="width:550px;height:450px "></div>
      </div>
    </div>

    <div class="con_data team">
      <h1 class="blue center"><a name="aaa">研发团队</a></h1>
      <div class="text">北京智砼兴华科技有限公司现拥有一支15人的科技研发队伍，拥有博士研发人员2人、硕士研究人员5人，本科及其它研发人员8人，研发团队聚焦智能化在土木工程及能源领域中的应用研究。</div>
      <div class="team_img">
        <img :src="item" v-for="(item,index) in img_2" :key="index" style="width: 580px;height: 323px">

      </div>
    </div>-->
    <div class="background">
      <div class="background-img"><img :src="img_1" style="width:450px;height:340px"></div>
      <div class="background-text">
        <p>关于我们</p>
      </div>
    </div>

    <div class="introduction">
      <h7>物联网&emsp;云计算&emsp;信息化应用</h7>
      <div class="introduction-text">公司定位为监测平台的开发商和服务商<br>
        致力于成为基础设施监测行业最好的平台开发商和服务商</div>
      <div class="introduction-img"><img :src="img_3" style="width:450px;height:340px"></div>
    </div>

    <div class="text-module1">
      <h9><br>&emsp;自动化检测体系<br></h9>
      <h11>&ensp;&emsp;&emsp;收集传感器</h11>
      <h8>实时</h8>
      <h11>数据，集成可视化报表<br></h11>
      <h10>&emsp;&emsp;☑桥梁&emsp;☑基坑&emsp;☑建筑物<br>&emsp;&emsp;☑边坡&emsp;☑隧道&emsp;☑大坝<br>&emsp;&emsp;☑路基&emsp;☑气象&emsp;☑尾矿库<br>&emsp;&emsp;☑特种设备&emsp;&emsp;&emsp;☑铁塔<br>&emsp;&emsp;☑临时设施(高支模,塔吊等)</h10>
    </div>

    <div class="text-module2">
      <h9><br>&emsp;&emsp;&emsp;低功耗应变 位移监测<br></h9>
      <h12>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;免维护使用时长达</h12>
      <h9>2</h9>
      <h12>年<br></h12>
      <h12>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;待机功耗低至</h12>
      <h9>10</h9>
      <h12>微安<br></h12>
      <h10>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;☑建筑结构&emsp;☑桥梁&emsp;☑矿山等</h10>
    </div>

    <!-- 新增图片轮播组件 -->
    <div class="image-carousel">
      <h1 class="blue center">开发团队</h1>
      <div class="text center">我们是一支15人的科技研发队伍，拥有博士研发人员2人、硕士研究人员5人，本科及其它研发人员8人，研发团队聚焦智能化在土木工程及能源领域中的应用研究。</div>
      <swiper ref="imageSwiper" :options="imageSwiperOption" class="image-swiper">
        <swiper-slide v-for="index in 9" :key="index" class="swiper-team">
          <img :src="require(`../../assets/image/2-${index}.png`)" :alt="`开发团队${index}`" class="carousel-image">
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 左右箭头 -->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="con_data proof">
      <h1 class="blue center">资质证书</h1>
      <div class="text center">10年行业经验，拥有完善的工业体系及产品研发能力</div>
        <swiper  ref="mySwiper"
                 :options="swiperOption"
                 class="swiper-content swiper-container">
          <swiper-slide class="store-right-item" v-for="(item,index) in win" :key="index">
            <img :src="item.ImgPath">
          </swiper-slide>
        </swiper>
    </div>


  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {map} from "core-js/internals/array-iteration";
require('swiper/dist/css/swiper.css')

export default {
  name: "index",
  components:{
    swiperSlide,
    swiper
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: '6',
        spaceBetween: 0,
        speed: 4000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        }
      },
      win:[],
      top:'',
      img_1:require('../../assets/02.png'),
      img_2:[require('../../assets/24.png'),require('../../assets/25.png')],
      img_3:require('../../assets/03.png'),


      // 新增轮播配置
      imageSwiperOption: {
        slidesPerView: 5, // 显示5张图片（当前1张+左右各2张）
        spaceBetween: 20, // 图片间距
        centeredSlides: true, // 当前图片居中
        loop: true, // 开启循环播放
        loopAdditionalSlides: 5, // 额外复制4张幻灯片用于循环
        initialSlide: 0, // 明确设置初始slide
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true,
        observeParents: true,
        // 添加响应式配置
        breakpoints: {
          1024: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 3, // 平板显示3张
          },
          480: {
            slidesPerView: 1, // 手机显示1张
          }
        }
      }
    }

  },
  mounted() {
    this.getImage()
    this.getTop()
  },
  methods:{
    //获取荣誉证书
    getImage(){
      let data={params:{ImgCate:3}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.win = res.data;
      })
    },
    //获取top 图片
    getTop(){
      let data={params:{ImgCate:5}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
  }
}
</script>

<style scoped>
.bt{
  text-align: center ;
  padding: 50px 0;
}
.con{
  display: flex;
  justify-content: left;
}
.text{
  padding:20px 50px 0 0;
  text-indent: 30px;
  line-height: 25px;
  color: #555;
  margin-bottom: 50px;
  font-size: 18px;
}
.team{
  margin: 90px auto;
}
.team_img{
  display: flex;
  justify-content: space-between;
}
.proof{
  position: relative;
  top: -300px;
  margin: 90px auto;
}

/* 新增轮播样式 */
.image-carousel {
  position: relative;
  top: -300px;
  margin: 60px auto;
  padding: 0 20px;
}

.image-swiper {
  height: 450px; /* 调整为合适高度 */
  width: 1500px;
  margin: 0 auto;
}

/* 新增图片放大相关样式 */
.swiper-team {
  overflow: hidden;
  transition: all 0.5s ease;
  transform: scale(0.7); /* 增加默认缩放比例 */
  opacity: 0.8; /* 提高默认透明度 */
}

.swiper-team.swiper-slide-active {
  transform: scale(1);
  opacity: 1;
  z-index: 2;
}

.swiper-team.swiper-slide-next,
.swiper-team.swiper-slide-prev {
  transform: scale(0.9); /* 增加相邻图片缩放比例 */
  opacity: 0.95;
  z-index: 1;
}

.carousel-image {
  width: 100%;
  height: 400px; /* 固定图片高度 */
  object-fit: cover; /* 保持比例并覆盖容器 */
}

/* 鼠标悬停效果优化 */
.swiper-team:hover .carousel-image {
  transform: scale(1.1);
}

.swiper-pagination-bullet-active {
  background-color: #1890ff;
}

.swiper-button-prev, .swiper-button-next {
  color: #1890ff;
}
.swiper-content{
  height: 240px;
}

/*最上方背景*/
.background {
  background-color: #f5f5f5; /* 浅灰色背景 */
  width: 100%; /* 宽度100% */
  height: 300px; /* 最小高度 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* 阴影效果 */
}
.background-img {
  position: relative;
  left: 60%;
  top: -15px;
}
.background-text{
  position: relative;
  font-size: 50px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 27%;
  top: -300px;
}
.background-link{/*背景 首页跳转链接*/
  font-size: 30px;
}
.background-link:hover{/*鼠标悬停动作*/
  transform-origin: top left;
  transform: scale(1.2);
}
.introduction{/*介绍*/
  position: relative;
  font-size: 35px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 21%;
  top:110px;
}
.introduction-text{
  font-size: 15px;
  position: relative;
  top: 20px;
  line-height: 2;
}
.introduction-img{
  position: relative;
  left: 35%;
  top: -150px;
}


/*介绍模块1*/
.text-module1{
  position: relative;
  top: -90px;
  left: 21%;
  height: 500px;
  box-shadow: 0px 5px 5px #bababa;
  width: 350px;
}
.text-module1:hover{
  transform: scale(1.01);
}
/*介绍模块2*/
.text-module2{
  position: relative;
  top: -450px;
  left: 48%;
  height: 360px;
  width: 600px;
  box-shadow: 0px 5px 5px #bababa;
}
.text-module2:hover{
  transform: scale(1.01);
}

</style>